module.exports = __webpack_public_path__ + "media/identify/icon_second-786f3827.svg";